import { tsValidateString, tsValidateUniqueId } from '@nu-art/ts-common';
import { MessagingDBGroup } from '../consts.js';
const Validator_ModifiableProps = {};
export const Validator_GeneratedProps_Topic = {
    type: tsValidateString(),
    refId: tsValidateUniqueId,
};
export const DBDef_Topic = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps_Topic,
    versions: ['1.0.0'],
    dbKey: 'topics',
    entityName: 'Topic',
    frontend: {
        group: MessagingDBGroup,
        name: 'topic',
    },
    backend: {
        name: 'topics',
    }
};
//# sourceMappingURL=db-def.js.map